<template>
  <v-col cols="12">
    <v-card elevation="0">
      <v-card-title
        dense
        class="subtitle-1 text-uppercase font-weight-medium flex justify-space-between v-card-title-gradient cursor-pointer"
        @click="$emit('toggle')"
      >
        <div class="d-flex align-center">
          <v-icon class="no-gradient mr-1">{{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
          {{ typePluralName }}
          <span class="ml-2 font-weight-regular text-lowercase">({{ items.length }})</span>
          <v-chip v-if="!active" x-small class="ml-2 text-none">{{ $t('item_types.inactive') }}</v-chip>
        </div>
        <div @click.stop>
          <v-btn
            v-if="active"
            @click="$emit('open-new', itemTypeId)"
            :fab="$vuetify.breakpoint.xsOnly"
            :color="$vuetify.breakpoint.xsOnly ? 'white' : 'primary'"
            class=""
            small
          >
            <v-icon class="no-gradient" :left="$vuetify.breakpoint.smAndUp">mdi mdi-plus</v-icon>
            <span v-if="$vuetify.breakpoint.smAndUp">{{ $t('items.create_new') }} {{ typeName.toLowerCase() }}</span>
          </v-btn>
        </div>
      </v-card-title>
      <template v-if="expanded">
        <v-card-text v-if="items.length > 0" class="pa-0">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">{{ $t('items.item_name') }}</th>
                  <th v-if="showUnit" class="text-left col-unit">{{ $t('items.unit') }}</th>
                  <th v-if="canViewPrice" class="text-right col-price">{{ $t('items.price') }}</th>
                  <th class="text-right col-actions"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id" @click="openItem(item)" class="cursor-pointer">
                  <td>{{ item.name }}</td>
                  <td v-if="showUnit">{{ item.unit || '-' }}</td>
                  <td v-if="canViewPrice" class="text-right">
                    <span v-if="item.price">{{ formatPrice(item.price) }} €</span>
                    <span v-else>-</span>
                  </td>
                  <td class="text-right">
                    <v-btn @click.stop="openItemRemoveDialog(item)" icon small v-if="isItemEditable">
                      <v-icon class="no-gradient" small style="color: red !important">mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
  
        <v-card-text v-else>
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ noContent }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </template>
    </v-card>
  </v-col>
</template>

<script>
import { isEditable, isTrackable, hasUnit, itemType, typeName, typePluralName } from '@/helpers/itemTypes';

export default {
  name: 'ItemsViewItemType',
  props: {
    noContent: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: null,
    },
    itemTypeId: {
      type: Number,
      default: null,
    },
    // Suljettu kortti näyttää vain otsikon ja määrän; avaus otsikosta (toggle-tapahtuma).
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      dialogItem: null,
    };
  },
  computed: {
    isItemEditable(){
      return isEditable(this.itemTypeId)
    },
    showUnit() {
      return hasUnit(this.itemTypeId);
    },
    canViewPrice() {
      return this.$isTenantAdmin && isTrackable(this.itemTypeId);
    },
    typeName() {
      return typeName(this.itemTypeId);
    },
    typePluralName() {
      return typePluralName(this.itemTypeId);
    },
    // Käytöstä poistettuun tyyppiin ei lisätä uusia nimikkeitä.
    active() {
      return itemType(this.itemTypeId)?.active !== false;
    },
  },
  methods: {
    openItem(item) {
      this.$emit('open-item', item.id);
    },
    openItemRemoveDialog(item) {
      this.$emit('open-item-remove-dialog', item);
    },
    formatPrice(price) {
      if (price === null || price === undefined) return '';
      return Number(price).toFixed(2).replace('.', ',');
    },
  },
};
</script>

<style scoped>
/* Kiinteät leveydet, jotta sarakkeet ovat linjassa korttien välillä; nimi saa loput tilasta. */
.col-unit {
  width: 120px;
}
.col-price {
  width: 140px;
}
.col-actions {
  width: 60px;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
